import {EMPTY_CODE, EMPTY_MODEL_DATE, EMPTY_PERCENT, EMPTY_TEXT, TraceableCode, TraceableDate, TraceablePercent, TraceableText} from "../../../shared/model/traceable";

export interface Shareholder {
    id?: number;
    fundInvestmentId?: number;
    date: TraceableDate;
    shareholderName: TraceableText;
    stake: TraceablePercent;
    source: TraceableCode;
}

export const EMPTY_SHAREHOLDER: Shareholder = {
    id: undefined,
    fundInvestmentId: undefined,
    date: EMPTY_MODEL_DATE,
    shareholderName: EMPTY_TEXT,
    stake: EMPTY_PERCENT,
    source: EMPTY_CODE
};
